import { createApiClient, getStoredAccessToken } from './client';
import {
  PILOT_API_BASE_URL,
  PILOT_ERASURE_PATH,
  PILOT_EVENT_BATCH_PATH,
  PILOT_FEATURE_ENABLED,
} from '../config/internalTestConfig';
import type { PilotEvent } from '../utils/internalTestPolicy';

const assertPilotEnabled = (): string => {
  if (!PILOT_FEATURE_ENABLED || PILOT_API_BASE_URL === null) {
    throw new Error('Staging pilot mode is disabled');
  }
  return PILOT_API_BASE_URL;
};

const createPilotClient = (accessToken?: string) =>
  createApiClient({
    baseUrl: assertPilotEnabled(),
    getToken: accessToken ? async () => accessToken : getStoredAccessToken,
  });

export const submitPilotEventBatch = async (
  events: PilotEvent[],
  accessToken?: string
): Promise<void> => {
  await createPilotClient(accessToken).post(PILOT_EVENT_BATCH_PATH, { events });
};

export const requestPilotErasure = async (accessToken?: string): Promise<void> => {
  await createPilotClient(accessToken).post(PILOT_ERASURE_PATH, {});
};
